/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import InputRegex from '../InputRegex';
import round from '~/utils/Number/round';

const getMask = (precision, config) => {
  return createNumberMask({
    thousandsSeparatorSymbol: '.',
    decimalSymbol: precision > 0 ? ',' : '',
    decimalLimit: precision,
    includeThousandsSeparator: true,
    allowDecimal: true,
    requireDecimal: true,
    allowNegative: true,
    allowLeadingZeroes: true,
    prefix: '',
    suffix: '',
    ...config,
  });
};

function inputValueToFloat(event) {
  return parseFloat(event.target.value.replace(/\./g, '').replace(/,/g, '.'));
}

class InputNumber extends React.Component {
  static propTypes = {
    value: PropTypes.oneOfType([
      PropTypes.oneOf([null]),
      PropTypes.string,
      PropTypes.number,
    ]),
    precision: PropTypes.number.isRequired,
    config: PropTypes.object,
    valueType: PropTypes.oneOf(['numeric', 'string']),
  };

  static getDerivedStateFromProps(nextProps) {
    return { mask: getMask(nextProps.precision, nextProps.config) };
  }

  static defaultProps = {
    precision: 3,
    config: {},
    valueType: 'numeric',
  };

  state = {
    mask: '',
  };

  handleChange = (event) => {
    const {
      onChange,
      precision,
      'state-name': stateName,
      valueType,
    } = this.props;

    let { value } = event.target;
    if (value !== '' && valueType === 'numeric') {
      value = round(inputValueToFloat(event), precision);
    }

    if (value === '') {
      value = null;
    }

    onChange({ [stateName]: value }, event);
  };

  onKeyDown = (event) => {
    const keyCode = Number(event.keyCode);
    const config = this.props.config;
    const allowNegative = (config || {}).allowNegative;

    if (allowNegative !== false && (keyCode === 109 || keyCode === 189)) {
      event.preventDefault();
      const {
        onChange,
        precision,
        'state-name': stateName,
        valueType,
      } = this.props;
      const number = round(inputValueToFloat(event), precision) * -1;

      onChange(
        { [stateName]: valueType === 'numeric' ? number : String(number) },
        event
      );
    }
  };

  inputValueFormat = () => {
    const { value } = this.props;
    if (typeof value === 'undefined') {
      return value;
    } else if (value === null || value === '') {
      return '';
    }
    return value.toString().replace(/\./g, ',');
  };

  render() {
    const {
      precision,
      onChange,
      config,
      value,
      inputProps,
      valueType,
      ...otherProps
    } = this.props;
    return (
      <InputRegex
        {...otherProps}
        value={this.inputValueFormat()}
        onChange={this.handleChange}
        onKeyDown={this.onKeyDown}
        mask={this.state.mask}
        inputProps={{
          ...inputProps,
          inputMode: 'numeric',
        }}
      />
    );
  }
}

export default InputNumber;
